import { GalleryItemType } from '@yme/utils/constants';
export const VIEW360 = GalleryItemType.VIEW360;
export const VIDEO = GalleryItemType.VIDEO;
export const IMAGE = GalleryItemType.IMAGE;
export const ACCESSORY_KEY = 'accessorized';
